module.exports = __webpack_public_path__ + "img/1.53f49528.gif";